import './PardotCompletionActionReferenceTypeFilter.scss';
import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import React from 'react';
import { Select } from 'antd';
import { UpdateQueryParams } from '@hooks';
import { getSonarObjectTypeAndSourceLabel, getSonarObjectTypeId, isPardotType } from '@sonar-software/sonar-ts-lib';
import { SonarObjectType, SonarObjectTypeId } from '@sonar-software/sonar-ts-types';

export type PardotCompletionActionReferenceTypeFilterQueryParams = {
	type?: SonarObjectTypeId;
};

export interface PardotCompletionActionReferenceTypeFilterProps {
	onChange: UpdateQueryParams<PardotCompletionActionReferenceTypeFilterQueryParams>;
	selected?: SonarObjectTypeId;
}

type SelectOption = {
	label: string;
	value: number;
};

const options: SelectOption[] = Object.values(SonarObjectType)
	.filter(isPardotType)
	.map((type) => ({
		label: getSonarObjectTypeAndSourceLabel(type) ?? '',
		value: getSonarObjectTypeId(type)
	}));

export const PardotCompletionActionReferenceTypeFilter: React.FC<PardotCompletionActionReferenceTypeFilterProps> = ({
	onChange,
	selected
}) =>
	<Select
		allowClear
		className='pardot-completion-action-reference-type-filter'
		filterOption={ caseInsensitiveContainsFilterOption }
		onChange={ (type) => onChange({ type }) }
		options={ options }
		placeholder='Filter by Type'
		value={ selected } />;

